export default "__VITE_ASSET__HeKSw75A__"